// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"cc707021","488":"7213179a","891":"85d1bed0"}[chunkId] + ".chunk.js";
};